import type { UserAccessRoleType } from '@econtractor/types';
import { isSameIdSet } from 'utils/helpers/list/isSameIdSet';

export const defaultUserRoles: UserAccessRoleType[] = ['manager', 'executor', 'seller'];
export const defaultUserStatuses = [1, 0];

export interface UserListFilterState {
    roles: UserAccessRoleType[];
    teamId: number | null;
    status: number[];
}

const isUserRole = (value: unknown): value is UserAccessRoleType =>
    value === 'manager' || value === 'executor' || value === 'seller';

const isSameRoleSet = (left: UserAccessRoleType[], right: UserAccessRoleType[]) => {
    if (left.length !== right.length) return false;
    const roles = new Set(left);
    return right.every((role) => roles.has(role));
};

export const defaultUserListFilter = (): UserListFilterState => ({
    roles: [...defaultUserRoles],
    teamId: null,
    status: [...defaultUserStatuses],
});

export const readUserListFilter = (raw: unknown): UserListFilterState => {
    const fallback = defaultUserListFilter();
    if (!raw || typeof raw !== 'object') return fallback;

    const data = raw as Record<string, unknown>;
    const roles = Array.isArray(data.roles) ? data.roles.filter(isUserRole) : fallback.roles;
    const status = Array.isArray(data.status)
        ? data.status.map((item) => Number(item)).filter((item) => item === 0 || item === 1)
        : fallback.status;
    const teamId = Number(data.teamId) > 0 ? Number(data.teamId) : null;

    return { roles, teamId, status };
};

export const isUserFilterActive = (filter: UserListFilterState) =>
    !isSameRoleSet(filter.roles, defaultUserRoles) || Boolean(filter.teamId) || !isSameIdSet(filter.status, defaultUserStatuses);
